var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTacheGauche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 779.335,
    height: 745.421,
    viewBox: "0 0 779.335 745.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sans_titre_1920_1200_px_14_",
    "data-name": "Sans titre (1920\\xA0\\xD7\\xA01200\\xA0px) (14)",
    d: "M267.975,51.833C346.389-48.035,510.967-10.2,588.271,90.12c22.987,29.83,128.75,140.963,114.311,230.715-12.743,79.208-94.395,153.514-168.5,173.028-55.622,14.646-59.836,25.562-66.794,46.532-12.654,38.133,9.81,48.527-116.365,56.571-80.936,0-121.787,61.522-200.107-8.079S66.675,468.715,41.492,345.819C5.541,170.374,78.156,239.772,193.087,148.5,217.1,129.43,240.783,86.464,267.975,51.833Z",
    transform: "matrix(-0.982, -0.191, 0.191, -0.982, 692.284, 744.952)",
    fill: "rgba(0,98,151,0.23)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTacheGauche);
export default __webpack_public_path__ + "static/media/tache_gauche.a6dc78436207c16ee523de4f1c02e6d1.svg";
export { ForwardRef as ReactComponent };